var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetingRoomConferenceHall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 23,
    viewBox: "0 0 40 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8393 15.1826C32.8393 16.833 31.562 18.4816 29.1507 19.7559C26.7688 21.0147 23.4333 21.8129 19.7134 21.8129C15.9935 21.8129 12.658 21.0147 10.2761 19.7559C7.8648 18.4816 6.5875 16.833 6.5875 15.1826C6.5875 13.5322 7.8648 11.8837 10.2761 10.6094C12.658 9.35058 15.9935 8.55234 19.7134 8.55234C23.4333 8.55234 26.7688 9.35058 29.1507 10.6094C31.562 11.8837 32.8393 13.5322 32.8393 15.1826Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7037,
    cy: 15.108,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1973 22.0206C16.3101 19.8935 17.2186 18.2002 18.465 17.5215M23.2086 22.0206C23.0957 19.8935 22.1808 18.2002 20.9313 17.5215",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.944,
    cy: 9.84827,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2012 16.7608C34.9393 16.7608 35.7117 16.7608 38.4498 16.7608C38.3369 14.6337 37.422 12.9405 36.1724 12.2617M33.7062 12.2617C33.2526 12.5087 32.8437 12.8901 32.5017 13.3779",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7037,
    cy: 3.64709,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9326 6.06055C21.804 6.53389 22.5127 7.50062 22.9001 8.7638M18.4664 6.06055C17.6249 6.51876 16.9375 7.43932 16.5449 8.64359",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4635,
    cy: 9.8717,
    r: 2.62209,
    stroke: "black",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16183 16.7842H0.957031C1.06991 14.6571 1.97836 12.9639 3.22481 12.2852M5.69102 12.2852C6.08431 12.4988 6.44445 12.8129 6.75687 13.2095",
    stroke: "black",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoomConferenceHall);
export default __webpack_public_path__ + "static/media/MeetingRoomConferenceHall.c75462f46207b59a9dfc03f31a7daf6e.svg";
export { ForwardRef as ReactComponent };